module.exports = __webpack_public_path__ + "fonts/MaterialIcons-Regular.5260ab8a.ttf";